export interface Founder {
  name: string;
  title: string;
  photo: string;
  bio: string[];
}

export interface TeamMember {
  name: string;
  tags?: string;
  photo?: string;
  bullets: string[];
}

export const founders: Founder[] = [
  {
    name: "閆立俠 老師",
    title: "離子紅光技術創始人 · 全國首席皮膚修復專家",
    photo:
      "https://storage.helloreaddy.io/project_files/5083fe3c-0446-4f05-ab30-834aed56ded7/f4ea6922-f4c1-4d80-a696-d7854b371852_compressed_527382d643ab4279a8041d25fb3eed41.webp",
    bio: [
      "疤痕修復領域的領導者之一，創立北京善世通達醫學研究院，專注皮膚全方面修復技術研發與推廣。主張採用非手術、基因療法進行疤痕修復，產品多為海洋生物製劑，強調安全性，面向孕婦和幼兒也可使用。",
      "2016 年成立善世通達愛心救助事業，聯合地方政府在兒童康復中心、福利院等地開展公益活動，幫助數十萬名患者治療康復。",
      "帶領公司獲得數十項榮譽，與央視網達成深度合作，店鋪連鎖機構遍布全國，上萬家加盟連鎖機構使用其產品技術。",
    ],
  },
  {
    name: "劉燕瓊 博士",
    title: "百症骨傷技術創始人 · 國際疼痛權威",
    photo:
      "https://storage.helloreaddy.io/project_files/5083fe3c-0446-4f05-ab30-834aed56ded7/916b125f-2810-4d10-8160-ffa65b91f2d7_compressed_2.webp",
    bio: [
      "著名處理痛症專家，擁有超過三十年疼痛經驗，是華人醫學界少數能夠以純物理療法處理慢性疼痛的醫師之一。",
      "Dr Lau (劉博士) 常與世界各地名醫、國家級國醫交流經驗、分享病例，在業界有重要地位，被稱為「痛症權威」。",
      "現任 ISHB 國際病變皮膚大健康及美業學會理事，致力將骨傷、疼痛管理與皮膚修復整合，建立完整的健康美業體系。",
    ],
  },
];

export const team: TeamMember[] = [
  {
    name: "方楚珊 Sabrina",
    tags: "ISHB 會長 ｜ 技術總監 ｜ 導師",
    photo:
      "https://storage.helloreaddy.io/project_files/5083fe3c-0446-4f05-ab30-834aed56ded7/a388db70-2ccd-4c08-b81f-5bae21e2e282_compressed_1.webp",
    bullets: [
      "國際病變皮膚協會 - 香港會長",
      "國際美容協會 - 副會長",
      "英國 TQUK / 國際十三大產後專科認證導師",
      "AI 超離子皮膚技術 / 紮肚 / 盆骨及骨盆閉合 / 養宮 / 磁叉通淋巴 / 孕婦按摩 / 催乳 / 美胸 / SMP 紋髮 & 生髮",
    ],
  },
];